import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const PublicServices = () => {
  useEffect(() => {
    // Scroll to the banner section on page load
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <section className="banner1">
        <div className="banner-overlay1"></div>
        <div className="banner-content">
          <h6 className="banner-subtitle">Services / Public Service</h6>
          <hr />
          <h1 className="banner-title">
            Revolutionizing Public <br /> Service with Cutting-edge Software
            Solutions
          </h1>

          <p>
            Empowering government and public service organizations with
            innovative <br /> technologies to enhance service delivery, improve
            efficiency, and ensure transparency in all operations.
          </p>

          <button className="banner-button mt-3">
            <Link to="/contact" className="text-decoration-none text-white">
              Let’s talk <span className="arrow">→</span>
            </Link>
          </button>
        </div>

        {/* Add the image element */}
        <img
          className="banner-image"
          src="https://img.freepik.com/free-photo/cute-young-couple-using-their-mobile-phone_23-2148648124.jpg"
          alt="Public Service Solutions"
        />
      </section>

      <section id="about" className="about py-5">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h6 className="col_yell text-center">Public Service</h6>
              <h2 className="text-center">
                Enhancing Public Service Efficiency and Transparency with
                Advanced Software Solutions
              </h2>
              <p className="text-center">
                Governments and public service organizations face increasing
                pressure to deliver efficient, transparent, and citizen-centric
                services. Our tailored software solutions provide the tools
                needed to streamline operations, improve citizen engagement, and
                ensure compliance with regulations.
              </p>
            </div>
          </div>
        </div>
      </section>
      <hr />

      <div className="container-fluid" style={{ padding: 40 }}>
        <div className="row serv_h1 mb-4">
          <div className="col-md-12">
            <div className="serv_h1l mb-4">
              <h2 className="text-center">Our Solutions</h2>
              <p className="text-center mb-0">
                Our software solutions for the public service sector help
                improve citizen engagement, streamline operations, ensure
                transparency, and manage government processes efficiently.
              </p>
            </div>
          </div>
        </div>

        <div className="row g-4">
          {/* <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h3 className="mb-3 card-title">
                <a href="#">Citizen Engagement Platforms</a>
              </h3>
              <p className="mb-4">
                Our citizen engagement platforms facilitate seamless communication between government agencies and citizens, allowing for better service delivery, feedback management, and transparency in public services.
              </p>
            </div>
          </div> */}

          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h3 className="mb-3 card-title">
                <a href="#">E-Government Solutions</a>
              </h3>
              <p className="mb-4">
                We offer e-government solutions that digitize key public sector
                services, improving access, efficiency, and convenience for
                citizens while reducing administrative burden for government
                entities.
              </p>
            </div>
          </div>

          {/* <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h3 className="mb-3 card-title">
                <a href="#">Government Compliance Software</a>
              </h3>
              <p className="mb-4">
                Our software helps government bodies adhere to regulatory frameworks, ensuring full compliance with local and international laws, and fostering accountability and transparency in their operations.
              </p>
            </div>
          </div> */}

          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h3 className="mb-3 card-title">
                <a href="#">Public Sector Resource Management</a>
              </h3>
              <p className="mb-4">
                We provide software solutions that help government organizations
                manage resources effectively, track budgets, and allocate funds,
                improving decision-making and the efficiency of public spending.
              </p>
            </div>
          </div>

          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h3 className="mb-3 card-title">
                <a href="#">Public Service Automation</a>
              </h3>
              <p className="mb-4">
                Our automation tools streamline repetitive administrative tasks,
                improving the efficiency and speed of government operations
                while minimizing human error and resource wastage.
              </p>
            </div>
          </div>

          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h3 className="mb-3 card-title">
                <a href="#">Data Analytics and Reporting</a>
              </h3>
              <p className="mb-4">
                Our advanced analytics solutions help government agencies
                collect, analyze, and report data more effectively, providing
                insights that drive smarter decision-making and policy
                formulation.
              </p>
            </div>
          </div>
        </div>
      </div>

      <hr />

      <section id="serv_h" className="p_3">
        <div className="container-xl">
          <div className="row serv_h3 mt-4 pt-5 pb-5 mx-0 px-4 bg-black text-white">
            <div className="col-md-8">
              <div className="serv_h3l">
                <h2 className="">
                  Ready to Transform Public Service Delivery?
                </h2>
                <p className="mt-3">
                  Leverage our software solutions to enhance citizen
                  satisfaction, optimize government operations, and ensure full
                  compliance with public sector regulations, driving greater
                  transparency and efficiency in all public service activities.
                </p>
                <button className="banner-button mt-3">
                  <Link
                    to="/contact"
                    className="text-decoration-none text-white"
                  >
                    Let’s talk <span className="arrow">→</span>
                  </Link>
                </button>
              </div>
            </div>
            <div className="col-md-4">
              <div className="serv_h3r">
                <div className="grid clearfix">
                  <figure className="effect-jazz mb-0">
                    <Link to="/contact">
                      <img
                        src="https://img.freepik.com/free-photo/colleagues-working-together-office_23-2148738266.jpg"
                        className="w-100"
                        alt="Public Service Solutions"
                      />
                    </Link>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PublicServices;
